import { createRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { UtilisateursPage } from '@/features/users/utilisateurs-page.js';
import { authenticatedRoute } from './authenticated.js';

/**
 * `/utilisateurs` — écran Utilisateurs (`02` §13). Pas de sélecteur de
 * boutique (comptes globaux, non liés à une boutique) et pas de filtre
 * (`02` §13 ne décrit qu'une liste + actions) : seuls page/tri vivent dans
 * l'URL, via `useDataTableUrlState` (`README-shell.md`).
 */
const usersSearchSchema = z.object({
  page: z.coerce.number().int().min(1).optional(),
  sortBy: z.string().optional(),
  sortDir: z.enum(['asc', 'desc']).optional(),
});

export const utilisateursRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/utilisateurs',
  validateSearch: (search: Record<string, unknown>) => usersSearchSchema.parse(search),
  component: UtilisateursPage,
});
